import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import client from 'api'

export const fetchAllRights = createAsyncThunk('rights/fetchAllRights', async (klasse: string) => {
    const url = `/api/ixweb/prightdb/`
    const params = {
        min_klasse: klasse,
        max_klasse: klasse,
        fields: 'modul_id,modul_right'
    }
    const res = await client.get(url, { params })

    return res.data.map((item: any) => {
        // special case: report modules with 'I' right should be treated as normal rights
        if (item.MODUL_ID.startsWith('C_LX') && item.MODUL_RIGHT === 'I') {
            return { module: item.MODUL_ID, right: ' ' }
        }

        return { module: item.MODUL_ID, right: item.MODUL_RIGHT }
    })
})

export const fetchLNR = createAsyncThunk('rights/fetchLNR', async (_=undefined, { rejectWithValue }: any) => {
    const url = `/api/ixweb/IxGlobalFunctions_IxGetCustomerLicense/`
    const res = await client.get(url)
    if (res.data.status === 'OK') {
        return res.data.data
    } else {
        return rejectWithValue(res.data.messages.error)
    }
})

export const fetchActiveLicenses = createAsyncThunk('rights/fetchActiveLicenses', async (_=undefined, { rejectWithValue }: any) => {
    // const url = ''
    // const res = await client.get(url)
    const res = {
        data: {
            status: 'OK',
            data: [],
            messages: { error: [] }
        }
    }
    if (res.data.status === 'OK') {
        return res.data.data
    } else {
        return rejectWithValue(res.data.messages.error)
    }
})

export const rightsSelector = createSelector(
    [
        (state: any) => state.rights,
        (_: any, module: string) => module
    ],
    (rights, module) => {
        if (!module) {
            return { right: '' }
        } else if (!rights ) {
            return { status: 'notloaded' }
        } else if (!rights[module]) {
            //console.log('rightsSelector for module', module, 'not found, returning empty right');
            return { right: ' ' } // needed for iX-Haus plus moduels for now, change the logic after implentation of the plus moduels rigths
        }

        return rights[module]
    }
)

const RightsSlice = createSlice({
    name: 'rights',
    initialState: {
        statusAll: 'notloaded',
        errorAll: null,

        statusLNR: 'notloaded',
        errorLNR: null,
        LNR: null,

        statusActiveLicenses: 'notloaded',
        activeLicenses: [],
        errorActiveLicenses: null,

        // individual rights will be stored by module name
        // e.g. rights['C_MODULE'] = { status: 'loaded', right: 'R' }

        // modules starting with `V_` are allowed when no user is logged in
        V_LOGIN: { status: 'loaded', right: '' },
        V_SSO_LOGIN: { status: 'loaded', right: '' },
        V_SSO_REDIRECT: { status: 'loaded', right: '' },

        A_INACTIVE: { status: 'loaded', right: '' },
    } as any,
    reducers: {
        userLoggedIn: (state) => {
            state['V_LOGIN'].right = 'X'
            state['V_SSO_LOGIN'].right = 'X'
            state['V_SSO_REDIRECT'].right = 'X'
        },
        userLoggedOut: (state) => {
            state['statusAll'] = 'notloaded'
            state['errorAll'] = null
            state['statusLNR'] = 'notloaded'
            state['errorLNR'] = null
            state['LNR'] = null
            state['V_LOGIN'].right = ''
            state['V_SSO_LOGIN'].right = ''
            state['V_SSO_REDIRECT'].right = ''
        },
        _setLNR: (state, action) => {
            state['LNR'] = action.payload
            state['statusLNR'] = 'loaded'
            state['errorLNR'] = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllRights.pending, (state) => {
            state.statusAll = 'loading'
        })
        builder.addCase(fetchAllRights.fulfilled, (state, action) => {
            state.statusAll = 'loaded'
            action.payload.forEach((item: any) => {
                state[item.module] = { status: 'loaded', right: item.right }
            })
        })
        builder.addCase(fetchAllRights.rejected, (state, action) => {
            state.statusAll = 'error'
            state.errorAll = action.error.message
        })

        builder.addCase(fetchLNR.pending, (state) => {
            state.statusLNR = 'loading'
        })
        builder.addCase(fetchLNR.fulfilled, (state, action) => {
            state.statusLNR = 'loaded'
            state.LNR = action.payload
        })
        builder.addCase(fetchLNR.rejected, (state, action) => {
            state.statusLNR = 'error'
            state.errorLNR = action.error.message
        })

        builder.addCase(fetchActiveLicenses.pending, (state) => {
            state.statusActiveLicenses = 'loading'
            state.activeLicenses = []
            state.errorActiveLicenses = null
        })
        builder.addCase(fetchActiveLicenses.fulfilled, (state, action) => {
            state.statusActiveLicenses = 'loaded'
            state.activeLicenses = action.payload
        })
        builder.addCase(fetchActiveLicenses.rejected, (state, action) => {
            state.statusActiveLicenses = 'error'
            state.errorActiveLicenses = action.error.message
        })
    }
})

export const { userLoggedIn, userLoggedOut, _setLNR } = RightsSlice.actions
export default RightsSlice.reducer
